import { IComponentOptions, IController, ITranscludeFunction } from "angular";
import { EmptyStateService } from "../empty-state.service";
import { IEmptyState } from "../models";

class EmptyStateBaseCtrl implements IController {
  // ---- Bindings ---- //
  emptyStateId: string;

  emptyState: IEmptyState;
  transcludeSlotsFilled: {
    actionButton: boolean;
  };

  static $inject = ["EmptyStateService", "$transclude"];
  constructor(private emptyStateService: EmptyStateService, private $transclude: ITranscludeFunction) {}

  $onInit(): void {
    this.transcludeSlotsFilled = {
      actionButton: this.$transclude.isSlotFilled("actionButton"),
    };
    this.emptyState = this.emptyStateService.getEmptyState(this.emptyStateId);
  }
}

export const EmptyStateBaseComponent: IComponentOptions = {
  controller: EmptyStateBaseCtrl,
  template: require("./empty-state-base.html"),
  bindings: {
    emptyStateId: "@",
  },
  transclude: {
    actionButton: "?actionButton",
  },
};
